<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Salary Grade Scale List"
                btnTitle="Add New"
                :showAddNew="true"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>SL</th>
                  <th>Grade Number</th>
                  <th>Grade Title</th>
                  <th>Description</th>
                  <th
                      v-for="scaleIndex in maxScaleLength"
                      :key="`scale-${scaleIndex}`"
                      class="text-right"
                  >
                    Scale {{ scaleIndex }}
                  </th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td>{{ i+1 }}</td>
                  <td>{{ item.grade_number }}</td>
                  <td>{{ item.grade_title }}</td>
                  <td>{{ item.description }}</td>
                  <td
                      v-for="scaleIndex in maxScaleLength"
                      :key="`scale-${scaleIndex}`"
                      class="text-right"
                  >
                    {{ item.scale_amounts[scaleIndex] ? commaFormat(item.scale_amounts[scaleIndex]) : '' }}
                  </td>
                  <td class="text-center">
                    <button class="btn btn-primary btn-sm"
                            @click="openAddEditModal(item)"
                            style="cursor: pointer"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <p v-if="tableItems && tableItems.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <Loader v-if="loading"/>

        <AddSalaryGradeScaleModal
            v-if="store.state.isModalOpenTwo"
            :formData="formData"
            @submitted="handleSalaryGradeScaleSubmit"
        />

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import AddSalaryGradeScaleModal from "@/components/molecule/company/hrm-payroll/salary-grade-scale/AddSalaryGradeScaleModal";
import figureFormatter from "@/services/utils/figureFormatter";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const maxScaleLength = ref(0);
const salaryStructureData = ref([]);
const params = ref({
    offset: 20,
});
const companyRoles = ref(null);
const additionalDealerQuery = ref({});
const additionalContactOption = ref({
  roles: 'employee',
  status: 'active'
});
const { commaFormat } = figureFormatter();
const formData = ref({
  grade_number: null,
  grade_title: null,
  description: null,
  scale_amount: [''],
})

const token = computed(() => localStorage.getItem('token'));

const handleSalaryGradeScaleSubmit = () => {
  getSalaryGradeScale()
};

const {
  fetchSalaryGradeScale,
} = handleHrPayroll()

function onClickAddNewButton() {
  formData.value.grade_number = null;
  formData.value.grade_title = null;
  formData.value.description = null;
  formData.value.scale_amount = [''];
  store.state.isModalOpenTwo = true
}

const openAddEditModal = (item) => {
  let query = getQuery()
  query += '&grade_serial=' + item.grade_serial
  salaryStructureData.value = []
  fetchSalaryGradeScale(query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data.data ? res.data.data[0] : [];

    formData.value.grade_serial = data.grade_serial;
    formData.value.grade_number = data.grade_number;
    formData.value.grade_title = data.grade_title;
    formData.value.description = data.description;
    formData.value.scale_amount_data = data.scale_amounts

    store.state.isModalOpenTwo = true
  });
}

const getSalaryGradeScale = async () => {
  const query = getQuery();
  loading.value = true
  tableItems.value = []
  maxScaleLength.value = 0;

  await fetchSalaryGradeScale(query).then(res => {
    if (!res.status){
      return
    }

    tableItems.value = res.data.data;
    maxScaleLength.value = res.data.max_scale_length
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
    return `?company_id=${route.params.companyId}`;
}

onMounted(() => {
    Promise.all([
      getSalaryGradeScale(),
    ])
})
</script>
